import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as constants from './constants';
import { actionTypes } from "./reducer";
import { LiveCallMinimized } from "./LiveCallMinimized";
import clsx from "clsx";
import { isFeatureEnabled } from "../../util/helpers";
import { toAbsoluteUrl } from "../../../Utils/_helpers";

export const DialPad = (props) => {
    const dispatch = useDispatch();
    const dialpadNumbers = [{
        symbol: 1
    },
    {
        symbol: 2,
    },
    {
        symbol: 3,
    },
    {
        symbol: 4,
    },
    {
        symbol: 5,
    },
    {
        symbol: 6,
    },
    {
        symbol: 7,
    },
    {
        symbol: 8,
    },
    {
        symbol: 9,
    },
    {
        style: {
            fontSize: 35,
            fontWeight: 400,
            position: 'relative',
            top: 7,
            justifyContent: 'center',
            flexBasis: '33.333333%',
            minWidth: '60px',
            color: '#1f4a94',
            alignItems: 'center',
            minHeight: '60px'
        },
        symbol: '*'
    },
    {
        symbol: 0
    },
    {
        style: {
            fontSize: 24,
            fontWeight: 400,
            justifyContent: 'center',
            flexBasis: '33.333333%',
            minWidth: '60px',
            color: '#1f4a94',
            alignItems: 'center',
            minHeight: '60px'
        },
        symbol: '#'
    }
    ];
    const [inputNumberArray, setInputNumberArray] = useState([]);
    const call_solution = useSelector(state => state.ticker.call_solution);

    const onNumberInput = (input) => {
        setInputNumberArray([...inputNumberArray, input]);
        // dispatch({ type: 'onCallStateChange', payload: { sip_dialpad_input: input } })
        props.callFlow.callAction(constants.CALL_COMMANDS.DIALPAD, { type: "dialpad_input", value: input }, dispatch);
    }

    const onBackPress = () => {
        let storeArr = [...inputNumberArray];
        storeArr.pop();
        setInputNumberArray(storeArr);
    }

    const DIALPAD_STATE = useSelector(state => {
        return state.ticker[constants.CALL_COMMANDS.DIALPAD];
    })

    const dispatchClosedDialpad = () => {
        if (DIALPAD_STATE == constants.DIALPAD_STATE.DIALPAD_OPENED) {
            const payload = {}
            payload[constants.CALL_COMMANDS.DIALPAD] = constants.DIALPAD_STATE.DIALPAD_CLOSED
            dispatch({ type: 'onCallStateChange', payload: payload })
        }
        dispatch({ type: actionTypes.onCallViewState, payload: { view_state: constants.CALL_VIEW_STATES.CALL_VIEW } })
    }

    return (
        <>
            {props.callFlow.isSipCall() && (call_solution == 'c2c' || call_solution == 'inbound_noncc') && isFeatureEnabled('is_dialpad_enabled') &&
                <div className="tmodal tmodal-dialog-scrollable call-ticker-dialog-sec">
                    <div className="tmodal-content">
                        <LiveCallMinimized {...props} disableSymbols={true} />
                        {DIALPAD_STATE == constants.DIALPAD_STATE.DIALPAD_OPENED &&
                            <>
                                <span style={{ position: 'absolute', width: '100%', height: 1, backgroundColor: '#EBEDF3', top: 155 }}></span>
                                <div className="container" style={{ position: 'relative' }}>
                                    <div className="d-flex mt-5 mb-8">
                                    <div className={`d-flex ${clsx({ "justify-content-center": inputNumberArray.length <= 6 })}
                                        ${clsx({ "justify-content-end": inputNumberArray.length > 6 })} align-items-center`}
                                        style={{ overflow: 'hidden', minHeight: 60, minWidth: 310 }}>
                                            {inputNumberArray.map((val, index) => (
                                                <>
                                                    {(inputNumberArray.length > 0 && index !== 0) && <span style={{ fontSize: 20, fontWeight: 500, color: '#464e5f' }}>-</span>}
                                                    <span key={index} style={{ padding: '0 10px', fontSize: 24, color: '#464e5f', fontWeight: 500 }}>{val}</span>
                                                </>
                                            ))}
                                        </div>
                                        <div className="d-flex align-items-center">
                                            {!inputNumberArray.length > 0 && <img className="header-close-icon" onClick={() => onBackPress()} src={toAbsoluteUrl("/media/sr/icons/dialpad/remove-digit-disable.svg")} style={{ height: 60, width: 60, marginBottom: -10 }} />}
                                            {inputNumberArray.length > 0 && <img className="header-close-icon" onClick={() => onBackPress()} src={toAbsoluteUrl("/media/sr/icons/dialpad/remove-digit-icon.svg")} style={{ height: 60, width: 60, marginBottom: -10 }} />}
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-end">
                                        <img onClick={() => dispatchClosedDialpad()} style={{ height: 32, width: 32 }} src={toAbsoluteUrl("/media/sr/icons/dialpad/arrow-down.svg")} />
                                    </div>

                                    <div className="col d-flex" style={{ width: '300px', margin: '0 auto', flexWrap: 'wrap', justifyContent: 'center' }}>
                                        {dialpadNumbers.map((val, index) =>
                                            <>
                                                <div className="" style={{ border: '1px solid #1f4a94', borderRadius: 30, margin: '5px 10px' }}>
                                                    <span key={index} className="d-flex" style={val.style ? val.style : {
                                                        justifyContent: 'center',
                                                        flexBasis: '33.333333%',
                                                        minWidth: '60px',
                                                        fontSize: 24,
                                                        color: '#1f4a94',
                                                        alignItems: 'center',
                                                        minHeight: '60px',
                                                    }} onClick={() => onNumberInput(val.symbol)}>{val.symbol}</span>
                                                </div>
                                            </>
                                        )}

                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>
            }
        </>
    )

}